import { Select, Spin } from 'antd';
import React, { useState, useEffect } from 'react';
import { getStripeProducts } from '../../api/stripe';
import { IWorkspace } from '../../types/workspaces';

const { Option } = Select;

let timeout: ReturnType<typeof setTimeout> | null;
let currentValue: string;

const fetch = (
    value: string,
    callback: (data: { value: string; text: string }[]) => void,
    fetching: React.Dispatch<React.SetStateAction<boolean>>,
) => {
    if (timeout) {
        clearTimeout(timeout);
        timeout = null;
    }
    currentValue = value;

    const call = () => {
        fetching(true);

        getStripeProducts(currentValue)
            .then(({ data }) => {
                const products = data.map((product: any) => ({
                    id: product.id,
                    name: product.name,
                }));

                callback(products);
            })
            .catch((err) => {
                console.log(err);
                fetching(false);
            })
            .finally(() => fetching(false));
    };

    timeout = setTimeout(call, 300);
};

const StripeProductSearch: React.FC<{
  placeholder: string;
  style?: React.CSSProperties;
  productSelectedData: ({ id, field, name }:{id: string, field: any, name: string}) => void;
  field: any
}> = ({
    productSelectedData, field, placeholder, style,
}) => {
    const [data, setData] = useState<any[]>([]);
    const [value, setValue] = useState<string>();
    const [fetching, setFetching] = useState<boolean>(false);

    useEffect(() => {
        fetch('', setData, setFetching);
    }, []);

    const handleSearch = (newValue: string) => {
        if (newValue) {
            fetch(newValue, setData, setFetching);
        } else {
            setData([]);
        }
    };

    const handleChange = (newValue: string) => {
        setValue(newValue);
        productSelectedData({
            id: data.find((w: IWorkspace) => w.name === newValue).id,
            field,
            name: newValue,
        });
    };

    const options = data.map((d) => <Option value={d.name} key={d.id}>{d.name}</Option>);

    return (
        <Select
            showSearch
            value={value}
            placeholder={placeholder}
            style={style}
            defaultActiveFirstOption={false}
            showArrow={false}
            filterOption={false}
            onSearch={handleSearch}
            onChange={handleChange}
            notFoundContent={fetching ? <Spin size="small" /> : null}
        >
            {options}
        </Select>
    );
};

export default StripeProductSearch;
